<app-user-management
  [columns]="[ { fieldName: '', label: 'Email', template: emailtpl},
  { fieldName: '', label: 'Name', template: nametpl},
  { fieldName: '', label: 'Mandanten-Admin', template: permissionstpl},
  { fieldName: '', label: 'Verfügbare Tools', template: tilestpl}]"
  [formFields]="[
    { fieldName: 'globalUser.email', label: 'Email', type:'text', readonly: true},
    { fieldName: 'globalUser.name',label: 'Name', type:'text', readonly: true},
    { fieldName: 'permissions', label: 'Mandanten-Admin', type: 'template', options: { template: mandantAdminTpl } },
    { fieldName: 'tiles', label: 'Verfügbare Tools', type: 'picklist', options: { selectValues: this.assignableTiles, bindLabel: 'name', bindValue: '_id', optionTemplate: tileOptionTemplate, preserveUnlistedValues: true, readonlyTargetValues: getSharedTilesForUser }  },
    { fieldName: 'tilePermissions', type: 'template', options: { template: tilePermissionsTpl } }
  ]"
  [formFieldsCreator]="[
    { fieldName: 'globalUser.email', label: 'Email', type: 'text', required: true},
    { fieldName: 'globalUser.name',label: 'Name', type: 'text', required: true},
    { fieldName: 'permissions', label: 'Mandanten-Admin', type: 'template', options: { template: mandantAdminTpl } }
  ]"
  [formFieldCreatorData]="{globalUser: {email: '', name: ''}, permissions: []}"
  [translatedLabels]="translatedLabels"
  [service]="frontendService"
  [saveUser]="performUpdateUser"
  [creating]="creating"
  (createUserEvent)="createUser($event);"
  (deleteUserEvent)="deleteUser($event);"
  i18n-newUserText="@@newUser"
  newUserText="Neuer Nutzer"
  [deleteButton]="true"
  [enableVkcs]="true"
></app-user-management>

<ng-template
  #emailtpl
  let-data="data"
>
  {{data.globalUser.email}}<app-test-user-badge [email]="data.globalUser.email"></app-test-user-badge>
</ng-template>

<ng-template
  #nametpl
  let-data="data"
>
  {{data.globalUser.name}}
</ng-template>

<ng-template
  #permissionstpl
  let-data="data"
>
  <span
    class="badge bg-primary m-1"
    *ngIf="isMandantAdmin(data)"
    i18n="@@userAdminMandantAdminBadge"
  >Mandanten-Admin</span>
</ng-template>

<ng-template
  #mandantAdminTpl
  let-data="data"
>
  <div class="form-check form-switch">
    <input
      type="checkbox"
      role="switch"
      class="form-check-input"
      id="mandantAdminSwitch"
      [checked]="isMandantAdmin(data)"
      (change)="toggleMandantAdmin(data, $any($event.target).checked)"
    >
    <label
      class="form-check-label"
      for="mandantAdminSwitch"
      i18n="@@userAdminMandantAdminLabel"
    >Mandanten-Admin dieser Organisation</label>
  </div>
</ng-template>

<ng-template
  #tilestpl
  let-data="data"
>
  <span
    class="badge user-tile-badge m-1 d-inline-flex align-items-center gap-1"
    *ngFor="let tile of data.tiles"
  >
    <app-tile-icon *ngIf="getTileById(tile) as fullTile" [tile]="fullTile" [inline]="true"></app-tile-icon>
    {{getTileById(tile)?.name ?? tile}}
  </span>
</ng-template>

<ng-template
  #tilePermissionsTpl
  let-data="data"
>
  <ng-container *ngFor="let tile of permissionTiles">
    <div class="tile-custom-permissions-row mb-2">
      <span class="form-label d-block mb-1">{{tile.name}}</span>
      <div
        class="form-check"
        *ngFor="let cp of tile.customPermissions"
      >
        <input
          type="checkbox"
          class="form-check-input"
          [id]="'tilePermission-' + tile._id + '-' + cp.key"
          [checked]="hasTilePermission(data, tile._id, cp.key)"
          (change)="toggleTilePermission(data, tile._id, cp.key)"
        />
        <label
          class="form-check-label"
          [for]="'tilePermission-' + tile._id + '-' + cp.key"
        >{{cp.label}}</label>
      </div>
    </div>
  </ng-container>
</ng-template>

<ng-template
  #tileOptionTemplate
  let-tile="item"
>
  <div class="tile-select-option">
    <span
      class="tile-select-option__icon"
      [ngStyle]="{'background-color': tile.color ?? '#6366f1'}"
    >
      <app-tile-icon [tile]="tile"></app-tile-icon>
    </span>
    <span class="tile-select-option__name">{{ tile.name }}</span>
  </div>
</ng-template>